const options: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: 'numeric',
};

export function formatDateTime(dateTime: string) {
  return new Date(dateTime).toLocaleDateString('en-US', options);
}

export function removeUnderscores(text: string) {
  return text.replace(/_/g, ' ');
}
